import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Section = styled.section`
    background-color: ${themeGet('colors.primary')};
    padding: 88px 0 0;
    `;
    
    export const ContentWrapper = styled.div`
    background-color: ${themeGet('colors.white')};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

export const Container = styled.div`
    background-color: ${themeGet('colors.white')};
    max-width: 1200px;
    width: 100%;
    padding: 40px 30px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;

    h1, h2, h3 {
        color: ${themeGet('colors.textPrimary')};
        margin-bottom: 16px;
    }

    h1 {
        font-size: 36px;
        font-weight: 700;
    }

    h2 {
        font-size: 28px;
        font-weight: 600;
    }

    h3 {
        font-size: 22px;
        font-weight: 500;
    }

    p, li {
        color: ${themeGet('colors.text')};
        font-size: 16px;
        line-height: 1.6;
    }

    ul {
        margin: 0;
        padding-left: 20px;
    }

    li {
        margin-bottom: 8px;
    }

    @media only screen and (max-width: 768px) {
        padding: 20px 15px;
        h1 {
            font-size: 28px;
        }
        h2 {
            font-size: 24px;
        }
        h3 {
            font-size: 18px;
        }
        p, li {
            font-size: 14px;
        }
    }
`;
